<ng-container *transloco="let t">
  <div class="pt-12">
    <h1 class="heading-t5" data-test-id="login-more-info.title">{{ t('loginMoreInfo.title') }}</h1>
    <h2 class="text-b2 font-medium font-PoppinsMedium mt-1" data-test-id="login-more-info.subtitle">{{ t('loginMoreInfo.subtitle') }}</h2>
  </div>

  <form (submit)="onSubmit($event)" class="mt-4" data-test-id="login-more-info.form">
    <div class="pt-5">
      <ls-select
        [disabled]="false"
        inputId="login_more_info_client"
        inputName="client"
        label="{{ t('loginMoreInfo.select_sponsor') }}"
        [dropdownPopoverShow]="false"
        [options]="clientOptions"
        [group]="form"
        controlName="client"
        (onSelect)="onClientSelect($event)"
        data-test-id="login-more-info.client-select"
      ></ls-select>
    </div>
    <div class="pt-5 pb-5">
      <ls-button
        btnType="submit"
        btnVariant="primary"
        size="lg"
        [upcase]="false"
        [label]="t('loginMoreInfo.submit')"
        [disabled]="submitting()"
        data-test-id="login-more-info.submit-button"
      ></ls-button>
    </div>
  </form>
</ng-container>
